import { combineReducers } from '@reduxjs/toolkit'
import formReducer from './form'
import reportReducer from './reports'
import stepsReducer from './steps'

const combinedReducer = combineReducers({
  reports: reportReducer,
  steps: stepsReducer,
  form: formReducer,
})

export default combinedReducer
